import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import HomePage from './pages/HomePage';
import ProfilePage from './pages/ProfilePage';
import SearchPage from './pages/SearchPage';
import ShortsPage from './pages/ShortsPage';
import Navbar from './components/Navbar';
import './App.css';

function App() {
  return (
    <Router>
      <div className="App bg-black min-h-screen text-white">
        <Navbar />
        <Routes>
          <Route path="/" element={<HomePage />} />
          {/* <Route path="/search" element={<SearchPage />} /> */}
          <Route path="/profile" element={<ProfilePage />} />
          <Route path="/shorts" element={<ShortsPage />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
